import styled from "styled-components/macro";

export const StyledLinkButton = styled.button`
	background: none !important;
	border: none;
	padding: 0 !important;

	/*input has OS specific font-family*/
	color: #6270c6;
	cursor: pointer;
	font-size: 21px;
`;
